
import React, { useState } from 'react';
import Typography from '../../components/Typography/Typography';
import Azure from './Azure';
import WhiteList from './WhiteList';
import Domain from './Domain';
import MismatchedUsers from './MismatchedUsers';

type TabType = 'azure' | 'whitelist' | 'domain' | 'mismatched-users';

const Documents = () => {
  const [activeTab, setActiveTab] = useState<TabType>('domain');

  const tabs = [
    { id: 'domain' as TabType, label: 'Domain' },
    { id: 'azure' as TabType, label: 'Azure Users' },
    { id: 'whitelist' as TabType, label: 'DB Whitelisting' },
    { id: 'mismatched-users' as TabType, label: 'Mismatched Users' },
  ];

  const renderActiveComponent = () => {
    switch (activeTab) {
      case 'azure':
        return <Azure />;
      case 'whitelist':
        return <WhiteList />;
      case 'domain':
        return <Domain />;
      case 'mismatched-users':
        return <MismatchedUsers />;
      default:
        return <Azure />;
    }
  };

  return (
    <div className="flex-grow flex flex-col mb-8 sm:mb-16 lg:mb-[104px]">
      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
        <div className="px-5 sm:px-6 pt-6 pb-4 border-b border-slate-100 bg-gradient-to-r from-white to-slate-50/80">
          <Typography
            variant="h2"
            className="font-bold title text-xl sm:text-2xl text-center text-k-dark-blue"
          >
            Welcome to KPMG Dashboard
          </Typography>
        </div>

        <div className="px-5 sm:px-6 pt-5 pb-2">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 p-1.5 bg-slate-100/80 rounded-xl border border-slate-200">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`relative px-3 py-2.5 text-xs sm:text-sm font-medium rounded-lg transition-all duration-200 ${
                  activeTab === tab.id
                    ? 'bg-white text-[#086DE1] shadow-sm ring-1 ring-[#086DE1]/15 font-semibold'
                    : 'text-slate-600 hover:text-slate-900 hover:bg-white/70'
                }`}
              >
                <span className="truncate block">{tab.label}</span>
                {activeTab === tab.id && (
                  <span className="absolute bottom-1 left-1/2 -translate-x-1/2 w-8 h-0.5 rounded-full bg-[#086DE1]" />
                )}
              </button>
            ))}
          </div>
        </div>

        <div className="px-5 sm:px-6 pb-6 pt-3">
          {renderActiveComponent()}
        </div>
      </div>
    </div>
  );
};

export default Documents;
